import { createSlice } from "@reduxjs/toolkit";

const retailersSlice = createSlice({
  name: "retailers",
  initialState: [],
  reducers: {
    addRetailersList: (state, action) => action.payload,
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = retailersSlice;

// Extract and export each action creator by name
export const { addRetailersList } = actions;

// Export the reducer, either as a default or named export
export default reducer;
